import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { PaymentsTerminal } from '../types';

import Context from './context';

interface Props {
    children: React.ReactElement;
}

const PaymentsTerminalsProvider = (props: Props) => {
    const { children } = props;
    const [data, setData] = useState<PaymentsTerminal[]>([]);
    const [selected, setSelected] = useState<PaymentsTerminal | null>(null);
    const [, setError] = useState<Error>();

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res: PaymentsTerminal[]) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const handleSetData = useCallback((item: PaymentsTerminal, newData: PaymentsTerminal[]) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const handlePutCallback = useCallback((response: PaymentsTerminal, newData: PaymentsTerminal[]) => {
        setData(newData);
        setSelected(response);
    }, []);
    const put = usePut(api, data, handlePutCallback, setError);

    const handleDeleteCallback = useCallback((id: string, newData: PaymentsTerminal[]) => {
        setData(newData);
        setSelected(null);
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                softDelete
            }}
        >
            {children}
        </Context.Provider>
    );
};

PaymentsTerminalsProvider.propTypes = {
    children: PropTypes.element.isRequired
};

export default PaymentsTerminalsProvider;
